import { type User } from './user-roles';

export const blankUser: User = {
    name: '',
    email: '',
    roles: []
};
